/* Quwa 2026 redesign — shared behaviors */
(function () {
  'use strict';

  /* ---------- Reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.qw-reveal:not(.qw-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('qw-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('qw-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
    /* safety sweep: reveal anything already in viewport that got stuck */
    setTimeout(function () {
      document.querySelectorAll('.qw-reveal:not(.qw-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('qw-in');
      });
    }, 1000);
  }

  /* ---------- Dispatch countdown (next daily cutoff) ---------- */
  function tickCountdowns() {
    document.querySelectorAll('[data-qw-countdown]').forEach(function (el) {
      var hour = parseInt(el.getAttribute('data-qw-countdown'), 10);
      if (isNaN(hour)) hour = 14;
      var now = new Date();
      var cutoff = new Date(now);
      cutoff.setHours(hour, 0, 0, 0);
      if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);
      var d = cutoff - now;
      var h = Math.floor(d / 3600000);
      var m = String(Math.floor(d % 3600000 / 60000)).padStart(2, '0');
      var s = String(Math.floor(d % 60000 / 1000)).padStart(2, '0');
      el.textContent = h + 'h ' + m + 'm ' + s + 's';
    });
  }

  /* ---------- Count-up stats ---------- */
  function initCountUps() {
    var els = document.querySelectorAll('[data-qw-countup]');
    if (!els.length) return;
    var run = function (el) {
      if (el.dataset.qwDone) return;
      el.dataset.qwDone = '1';
      var target = parseFloat(el.getAttribute('data-qw-countup')) || 0;
      var suffix = el.getAttribute('data-qw-suffix') || '';
      var start = null, dur = 1200;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString('en-GB') + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.intersectionRatio >= 0.4) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: [0.4] });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Dark mode: cursor glow / shimmer ---------- */
  function initGlow() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(pointer: fine)').matches) return;
    if (document.querySelector('.qw-glow')) return;

    var glow = document.createElement('div');
    glow.className = 'qw-glow';
    glow.setAttribute('aria-hidden', 'true');
    glow.innerHTML = '<span class="qw-glow-a"></span><span class="qw-glow-b"></span>';
    document.body.appendChild(glow);

    var tx = window.innerWidth / 2, ty = window.innerHeight / 2;
    var x = tx, y = ty, x2 = tx, y2 = ty, running = false;

    function frame() {
      x += (tx - x) * 0.12;
      y += (ty - y) * 0.12;
      x2 += (tx - x2) * 0.045;
      y2 += (ty - y2) * 0.045;
      glow.style.setProperty('--qw-gx', x.toFixed(1) + 'px');
      glow.style.setProperty('--qw-gy', y.toFixed(1) + 'px');
      glow.style.setProperty('--qw-gx2', x2.toFixed(1) + 'px');
      glow.style.setProperty('--qw-gy2', y2.toFixed(1) + 'px');
      if (Math.abs(tx - x) > 0.4 || Math.abs(ty - y) > 0.4 || Math.abs(tx - x2) > 0.4 || Math.abs(ty - y2) > 0.4) {
        requestAnimationFrame(frame);
      } else {
        running = false;
      }
    }

    window.addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY;
      glow.classList.add('on');
      if (!running) { running = true; requestAnimationFrame(frame); }
    }, { passive: true });

    document.addEventListener('pointerleave', function () { glow.classList.remove('on'); });
  }

  /* ---------- Money ---------- */
  window.qwMoney = function (pence) {
    var n = pence / 100;
    var str = (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
    return '\u00A3' + str;
  };

  /* ---------- Cart: add items and open theme drawer ---------- */
  window.qwAddToCart = function (items, button) {
    var origLabel;
    if (button) { origLabel = button.textContent; button.disabled = true; button.textContent = 'Adding\u2026'; }
    var body = {
      items: items,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    };
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) throw new Error(res.description || 'Could not add to cart');
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
        drawer.renderContents(res);
      } else {
        /* fall back to cart page */
        window.location.href = '/cart';
        return;
      }
      if (button) { button.textContent = 'Added \u2713'; setTimeout(function () { button.textContent = origLabel; button.disabled = false; }, 1600); }
      document.dispatchEvent(new CustomEvent('qw:cart:added'));
    }).catch(function (err) {
      console.error('[quwa-2026]', err);
      if (button) { button.textContent = origLabel; button.disabled = false; }
      alert(err.message || 'Sorry, that could not be added to your bag.');
    });
  };

  /* ---------- Boot ---------- */
  function boot() {
    initReveal();
    initCountUps();
    tickCountdowns();
    initGlow();
    setInterval(tickCountdowns, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { initReveal(); initCountUps(); tickCountdowns(); });
})();
